var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaymentMenu = function SvgPaymentMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.326 5.761-3.973-4.083a.582.582 0 0 0-.418-.178H4.091a.599.599 0 0 0-.591.607v15.786c0 .336.264.607.59.607h11.82c.326 0 .59-.271.59-.607v-11.7a.62.62 0 0 0-.174-.432Zm-1.189.71h-3.475v-3.57l3.475 3.57Zm.034 10.663H4.83V2.866h5.576v4.098c0 .212.082.414.227.564.146.15.343.233.549.233h3.989v9.373ZM9.852 12.01H6.455a.15.15 0 0 0-.148.152v.91a.15.15 0 0 0 .148.152h3.397a.15.15 0 0 0 .148-.151v-.911a.15.15 0 0 0-.148-.152ZM6.307 9.583v.91a.15.15 0 0 0 .148.152h7.09a.15.15 0 0 0 .148-.152v-.91a.15.15 0 0 0-.147-.152H6.455a.15.15 0 0 0-.148.152Z",
    fill: "#999"
  })));
};
export default SvgPaymentMenu;